import React from "react";
import { ModalWrapper } from "../ModalWrapper/ModalWrapper";
import { kebabToCamelCase } from "../../helpers";

const DIALOG_CONFIGS = {
  "duplicate confirmed": {
    title: "Confirm Manuscript",
    message: "Do you want to request confirmation from the other publisher?",
    options: [
      {
        id: "request-confirmation",
        label: "Request confirmation",
        type: "checkbox"
      }
    ]
  },
  "suspect paper mill": {
    title: "Paper Mill Suspect",
    options: [
      {
        id: "add-to-signalcheck",
        label: "Add to SignalCheck",
        type: "checkbox",
        defaultValue: true
      },
      {
        id: "comment",
        label: "Comment:",
        type: "textarea",
        rows: 3
      }
    ]
  }
};

function convertDialogOptionKeys(options) {
  return Object.entries(options).reduce((result, [key, value]) => {
    if (value !== "" && value !== false && value !== null && value !== undefined) {
      result[kebabToCamelCase(key)] = value;
    }
    return result;
  }, {});
}

const ConfirmationDialog = ({ actionType, isOpen, onClose, onApply }) => {
  const [optionsState, setOptionsState] = React.useState({});
  const config = DIALOG_CONFIGS[actionType] || {};

  React.useEffect(() => {
    if (isOpen && config.options) {
      const initialState = {};
      config.options.forEach(option => {
        if (option.defaultValue !== undefined) {
          initialState[option.id] = option.defaultValue;
        } else if (option.type === "checkbox") {
          initialState[option.id] = false;
        } else {
          initialState[option.id] = "";
        }
      });
      setOptionsState(initialState);
    }
  }, [isOpen, actionType]);

  const handleOptionChange = (optionId, value) => {
    setOptionsState(prev => ({
      ...prev,
      [optionId]: value
    }));
  };

  const handleApply = () => {
    onApply(convertDialogOptionKeys(optionsState));
  };

  if (!isOpen || !config.title) return null;

  return (
    <ModalWrapper
      isOpen={isOpen}
      onClose={onClose}
      title={config.title}
      modalClassSize="modal-md"
    >
      {config.message && <div className="mb-3">{config.message}</div>}

      {config.options?.map(option => (
        <div className="mb-3" key={option.id}>
          {option.type === "checkbox" ? (
            <label className="d-flex align-items-center">
              <input
                type="checkbox"
                checked={!!optionsState[option.id]}
                onChange={e => handleOptionChange(option.id, e.target.checked)}
              />
              <span className="ms-2">{option.label}</span>
            </label>
          ) : option.type === "textarea" ? (
            <>
              <label className="form-label">{option.label}</label>
              <textarea
                className="form-control"
                value={optionsState[option.id] || ""}
                onChange={e => handleOptionChange(option.id, e.target.value)}
                rows={option.rows || 3}
              />
            </>
          ) : option.type === "select" ? (
            <>
              <label className="form-label">{option.label}</label>
              <select
                className="form-select"
                value={optionsState[option.id] || ""}
                onChange={e => handleOptionChange(option.id, e.target.value)}
              >
                {option.choices.map(choice => (
                  <option key={choice.value} value={choice.value}>
                    {choice.label}
                  </option>
                ))}
              </select>
            </>
          ) : null}
        </div>
      ))}

      <div className="d-flex justify-content-end">
        <button className="btn btn-secondary me-2" onClick={onClose}>Cancel</button>
        <button className="btn btn-primary" onClick={handleApply}>Submit</button>
      </div>
    </ModalWrapper>
  );
};

export default ConfirmationDialog;
